import { Button } from "baseui/button";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "baseui/modal";
import { useState } from "react";
import { CreateObjectInstanceCommand,  useCreateObjectMutation } from "../../../../services/objects";
import { schema } from '..'
import { FormControl } from "baseui/form-control";
import { Input, MaskedInput } from "baseui/input";
import { FormattedMessage } from "react-intl";
import { useReportMutationState } from "../../../../hooks/useReportMutationState";
import { IsValidIpAddress } from "../../../../utils/validations";

export interface AddBacnetDeviceDialogProps {
    parentId: string;
    parentResouceGroupId: string;
    isOpen: boolean;
    setIsOpen: any;
    onCreated: any;
}

const AddBacnetDeviceDialog = ({ parentId, parentResouceGroupId, isOpen, setIsOpen, onCreated }: AddBacnetDeviceDialogProps) => {

    const [createObject, createObjectResult] = useCreateObjectMutation();
    const [isValidIp,setIsValidIp] = useState<boolean>(true);
    const [state, setState ] = useState({
       // description: '',
        bacnetDeviceId: 0,
        ipAddress: ''
    })
    useReportMutationState(createObjectResult,onCreated);

    function onBacnetDeviceIdChanged(args: any) {
        setState(prevState => ({
            ...prevState,    // keep all other key-value pairs
            bacnetDeviceId: args.target.value,
            //description: `BACnetDevice${args.target.value}`
          }));
    }
    function onIpAddressChanged(args: any) {
        setState(prevState => ({
            ...prevState,    // keep all other key-value pairs
            ipAddress: args.target.value
          }));
          setIsValidIp(IsValidIpAddress(args.target.value));
    }

    function onCreateClick(): void {

        const cmd: CreateObjectInstanceCommand = {
            name: `BACnetDevice${state.bacnetDeviceId}`,
            resourceGroupId: parentResouceGroupId,
            description: '',
            schema: schema,
            parentId: parentId,
            properties: [
                { key: 'DeviceId', value: state.bacnetDeviceId },
                { key: 'IpAddress', value: state.ipAddress },
                { key: 'NoConnection', value: true }
            ],
            sourceRelations: [
                { targetId: parentId, relationName: 'IsConnectedTo'}
            ]
        }
        createObject(cmd);
    }

    const inputsValid = state.bacnetDeviceId > 0 && state.ipAddress !== '' && isValidIp;

    return (

        <Modal closeable onClose={() => setIsOpen(false)} isOpen={isOpen}>
            <ModalHeader>Add a new Edge Device</ModalHeader>
            <ModalBody>
                <FormControl
                    label={<FormattedMessage id="Devices.DeviceId" defaultMessage="BACnet Device ID" />}
                    caption={<FormattedMessage id="Devices.TextDeviceId" defaultMessage="Enter the BACnet Device ID" />}
                >
                    <Input type='number' value={state.bacnetDeviceId} onChange={onBacnetDeviceIdChanged} required />
                </FormControl>

                <FormControl
                error={!isValidIp}
                    label={<FormattedMessage id="Devices.IPAddress" defaultMessage="IP Address" />}
                    caption={<FormattedMessage id="Devices.TextIPAddress" defaultMessage="Enter the IP Address of the BACnet Device" />}
                >
                    <Input value={state.ipAddress} onChange={onIpAddressChanged} required placeholder="Enter IP Address ..." />
                </FormControl>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onCreateClick} disabled={!inputsValid} isLoading={createObjectResult.isLoading}>Add</Button>
            </ModalFooter>
        </Modal>

    )
}

export default AddBacnetDeviceDialog;

